module.exports = __webpack_public_path__ + "img/img_03_brand_retail@3x.7f44d293.png";